

//qnbar平台工具的基础配置
//var PT = require('./vendor/qnbar/platform.js');
import Platform from './vendor/qnbar/platform.js'

var PT = new Platform.Platform();
PT.config.env = "release";
PT.config.hostBaseUrl = 'https://mm.qnbar.com/';
PT.config.platformUsagespace = 'PT_MIX_BZ';
PT.config.apiBaseUrl = 'https://apih.qnbar.com/';
PT.config.qnloginBaseUrl = "https://login.qnbar.com/";
PT.config.qnloginPlatformNo = 10;  
PT.config.loginJumpBackUrl = encodeURIComponent(PT.config.hostBaseUrl);
PT.config.wsHost = "ws.qnbar.com";
PT.config.wsPort = "16668";
PT.config.wsProto = "wss";
PT.init();

export default {
    PT : PT
}


// WEBPACK FOOTER //
// ./src/env.release.js